import shortUrl from "@/util/shortUrl";
import crypto from "@/util/crypto";
import publicUtil from "@/util/public";
import auth from "@/util/auth";
import {getCryptoUserInfo} from "@/util/cryptoLocalStorage";

export default {
    process(div) {
        let links = div.getElementsByTagName('a');

        for (let i = 0; i < links.length; i++) {
            let href = links[i].getAttribute('href');

            if (href && (href.startsWith('https://o-test.oinapp.com') || href.startsWith('https://o.oinapp.com'))) {
                links[i].addEventListener('click', (event) => handleShortUrl(event, href));
            } else if (href && (href.startsWith('https://survey-test.oinapp') || href.startsWith('https://survey.oinapp'))) {
                links[i].addEventListener('click', (event) => handleClickUrl(event, href, TYPE.INTERNAL));
            } else {
                links[i].addEventListener('click', (event) => handleClickUrl(event, href, TYPE.EXTERNAL));
            }
        }
    }
}


const handleShortUrl = (event, url) => {
    event.preventDefault();

    shortUrl.getOriginalURL(url).then(res => {
        handleClickUrl(event, res.url);
    })
};

const TYPE = {INTERNAL: 0,  EXTERNAL: 1}

const handleClickUrl = (event, url, type) => {
    event.preventDefault();

    if (type === TYPE.INTERNAL) {
        const getUrlParam = urlDivideAry => {
            let urlParam = urlDivideAry[1];
            let paramDecode = decodeURIComponent(urlParam);
            let paramDecrypto = crypto.decryptText(paramDecode);
            return JSON.parse(paramDecrypto);
        }

        if (url.includes('questionnaire/')) {
            let urlDivideAry = url.split('questionnaire/');
            if (urlDivideAry.length === 2) {
                let paramData = getUrlParam(urlDivideAry);

                //需不需要登入？
                if (paramData.isLogin) {
                    let isLogin = auth.isAdminLogin();
                    if (isLogin) {
                        // const userData = JSON.parse(localStorage.getItem('userInfo') || "");
                        const userData = getCryptoUserInfo();
                        let name = userData.name;
                        let tel = userData.phone;
                        let combo = name + ';' + tel + ';APP';
                        let crypto_ = crypto.encryptText(combo);
                        let param = encodeURIComponent(crypto_);

                        url = url + '/' + param;
                    }
                }
            }
        } else if (url.includes('form/')) {
            let urlDivideAry = url.split('form/');
            if (urlDivideAry.length === 2) {
                let paramData = getUrlParam(urlDivideAry);
                paramData.params.isCordova = publicUtil.isCordova();
                let param = encodeURIComponent(crypto.encryptText(JSON.stringify(paramData)));
                url = urlDivideAry[0] + 'form/' + param;
                let isLogin = auth.isAdminLogin();
                if (isLogin) {
                    // const userData = JSON.parse(localStorage.getItem('userInfo') || "");
                    const userData = getCryptoUserInfo();
                    let name = userData.name;
                    let tel = userData.phone;
                    let combo = name + ';' + tel + ';';
                    combo += publicUtil.isCordova() ? 'app' : 'web';
                    let crypto_ = crypto.encryptText(combo);
                    let param = encodeURIComponent(crypto_);

                    url = url + '/' + param;
                }
            }
        }

        let isCordova = !!window.cordova;
        if (isCordova) {
            publicUtil.openUrlWithCloseBtn(url);
        } else {
            window.open(url);
        }
    } else if (type === TYPE.EXTERNAL) {
        publicUtil.openUrl(url);
    }
}